import React from "react";
import { FiInstagram } from "react-icons/fi";

function FollowUs() {
  const instagramImages = [
    "assets/follow-us/1.jpg",
    "assets/follow-us/2.jpg",
    "assets/follow-us/3.jpg",
    "assets/follow-us/4.jpg",
    "assets/follow-us/5.jpg",
    "assets/follow-us/6.jpg",
    "assets/follow-us/7.jpg",
    "assets/follow-us/8.jpg",
  ];
  return (
    <section id="follow-us">
      <div className="relative p-4 text-center heading">
        <h5 className="font-primaryFont text-2xl">Follow us on Instagram</h5>
      </div>
      <div className="justify-center grid grid-cols-4 md:grid-cols-8 instagram-gallary-container cursor-pointer">
        {instagramImages.map((item, index) => {
          return (
            <div key={index} className="relative w-full card group">
              <img
                src={item}
                alt={"instagramPost" + index + 1}
                className="brightness-100 hover:brightness-50 transition-all duration-300"
              />
              <div className="group-hover:block top-1/2 left-1/2 absolute hidden transform transition-all -translate-x-1/2 -translate-y-1/2 duration-500">
                <FiInstagram className="text-2xl text-white"/>
              </div>
            </div>
          );
        })}
      </div>

    </section>
  );
}

export default FollowUs;
